import useEntityClasses from './useEntityClasses'

export default useEntityClasses
